export default {
  RECORDER_INIT: 'RECORDER_INIT',

  RECORDER_RECORDING_START: 'RECORDER_RECORDING_START',
  RECORDER_RECORDING_END: 'RECORDER_RECORDING_END',

  RECORDER_ADD_THUMBNAIL: 'RECORDER_ADD_THUMBNAIL',
  RECORDER_SET_THUMBNAIL: 'RECORDER_SET_THUMBNAIL',

  RECORDER_SET_MESSAGE: 'RECORDER_SET_MESSAGE',
  RECORDER_SET_BLOB: 'RECORDER_SET_BLOB',
  RECORDER_ADD_BLOB: 'RECORDER_ADD_BLOB',
  RECORDER_SET_MEDIA_STREAM: 'RECORDER_SET_MEDIA_STREAM',
  RECORDER_SET_RECORDER: 'RECORDER_SET_RECORDER',

  RECORDER_SET_IS_EXTERNAL_VIDEO: 'RECORDER_SET_IS_EXTERNAL_VIDEO',
  RECORDER_SET_DURATION: 'RECORDER_SET_DURATION',
  RECORDER_SET_LINK_ID: 'RECORDER_SET_LINK_ID',

  RECORDER_SET_MESSAGE_TEMPLATE: 'RECORDER_SET_MESSAGE_TEMPLATE',
  RECORDER_SET_SEND_TYPE: 'RECORDER_SET_SEND_TYPE',
  RECORDER_SET_SHOW_THUMBNAIL_SELECTION:
    'RECORDER_SET_SHOW_THUMBNAIL_SELECTION',
  RECORDER_SET_MANUAL_SCHEDULE_DATE_TIME:
    'RECORDER_SET_MANUAL_SCHEDULE_DATE_TIME',
  RECORDER_SET_SCHEDULE_GREET: 'RECORDER_SET_SCHEDULE_GREET',
  RECORDER_SET_VIDEO_SOURCE_URL: 'RECORDER_SET_VIDEO_SOURCE_URL',

  RECORDER_SET_DEVICE_ERROR_STATUS: 'RECORDER_SET_DEVICE_ERROR_STATUS',
  RECORDER_SET_THUMBNAILS: 'RECORDER_SET_THUMBNAILS',
} as const;
